import { createSlice } from '@reduxjs/toolkit';
import { setIsLoading } from '../isLoading.slice';
import axios from 'axios';
import { logOut } from '../../../resources/utils';


export const contractsSlice = createSlice({
    name: 'contracts',
    initialState: {
        items: [],
        item: {},
        message: "",
        error: "",
    },
    reducers: {
        initialStateContract: (state, action) => {
            return {
                items: [],
                item: {},
                message: "",
                error: "",
            }
        },
        setContracts: (state, action) => {
            return {
                items: action.payload,
                item: {},
                message: "",
                error: "",
            }
        },
        setContract: (state, action) => {
            return {
                items: [],
                item: action.payload,
                message: "",
                error: "",
            }
        },
        setContractMessages: (state, action) => {
            return {
                items: [],
                item: {},
                message: action.payload,
                error: "",
            }
        },
        setContractError: (state, action) => {
            return {
                items: [],
                item: {},
                message: "",
                error: action.payload,
            }
        },
    }
})

export const getContractsThunk = () => dispatch => {
    dispatch(setIsLoading(true));
    axios.get(`/contracts`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setContracts(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setContractError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const getContractThunk = (contract_id) => dispatch => {
    dispatch(setIsLoading(true));
    axios.get(`/contracts/${contract_id}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setContract(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setContractError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};


export const createContractThunk = (data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.post(`/contracts/createContract`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setContractMessages(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setContractError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};


export const updateContractThunk = (contract_id, data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.put(`/contracts/updateContract/${contract_id}`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setContractMessages(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setContractError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};


export const deleteContractThunk = (contract_id) => dispatch => {
    dispatch(setIsLoading(true));
    axios.delete(`/contracts/${contract_id}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setContractMessages(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setContractError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const { 
    initialStateContract,
    setContracts,
    setContract,
    setContractMessages,
    setContractError
} = contractsSlice.actions;

export default contractsSlice.reducer;